import {
  IonButton,
  IonContent,
  IonHeader,
  IonImg,
  IonModal,
  IonText,
  IonToolbar,
} from "@ionic/react";
import React, { useMemo } from "react";
import { UAParser } from "ua-parser-js";

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
};

type DeviceOS = "android" | "ios" | "other";

const parser = new UAParser();

function getDeviceOS(): DeviceOS {
  const result = parser.getResult();
  const os = result.os.name?.toLowerCase() ?? "";
  if (os.includes("android")) return "android";
  if (os.includes("ios") || os.includes("iphone") || os.includes("ipad"))
    return "ios";
  return "other";
}

const ANDROID_STEPS = [
  {
    title: "שלב 1",
    text: "לחץ על תפריט שלוש הנקודות (⋮) בפינה הימנית העליונה של הדפדפן",
  },
  {
    title: "שלב 2",
    text: "בחר 'הוסף למסך הבית' או 'התקן אפליקציה'",
  },
  {
    title: "שלב 3",
    text: "לחץ על 'התקן' או 'הוסף' לאישור",
  },
];

const IOS_STEPS = [
  {
    title: "שלב 1",
    text: "פתח את האתר בדפדפן Safari (חובה להשתמש ב-Safari)",
  },
  {
    title: "שלב 2",
    text: "לחץ על כפתור השיתוף (ריבוע עם חץ) בתחתית המסך",
  },
  {
    title: "שלב 3",
    text: "גלול למטה ובחר 'הוסף למסך הבית'",
  },
  {
    title: "שלב 4",
    text: "לחץ על 'הוסף' בפינה הימנית העליונה",
  },
];

export function PWAInstallHelpSheet({ isOpen, onDismiss }: Props) {
  const deviceOS = useMemo(() => getDeviceOS(), []);

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      breakpoints={[0.25, 0.5, 0.75, 0.9]}
      initialBreakpoint={0.75}
    >
      <IonHeader>
        <IonToolbar>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              padding: "8px 0",
            }}
          >
            <IonImg
              src="/icon-192.png"
              alt="BeTogether"
              style={{ width: 48, height: 48, marginBottom: 4 }}
            />
            <IonText>
              <strong>BeTogether – מקלטים</strong>
            </IonText>
          </div>
        </IonToolbar>
      </IonHeader>

      <IonContent className="ion-padding">
        {(deviceOS === "android" || deviceOS === "other") && (
          <div>
            <IonText color="medium">
              <p style={{ marginBottom: 24 }}>
                עקוב אחר השלבים הבאים כדי להוסיף את האפליקציה למסך הבית ב-Android:
              </p>
            </IonText>
            {ANDROID_STEPS.map((step, idx) => (
              <div key={idx} style={{ marginBottom: 24 }}>
                <h3>{step.title}</h3>
                <IonText>
                  <p>{step.text}</p>
                </IonText>
              </div>
            ))}
          </div>
        )}

        {deviceOS === "ios" && (
          <div>
            <IonText color="medium">
              <p style={{ marginBottom: 24 }}>
                עקוב אחר השלבים הבאים כדי להוסיף את האפליקציה למסך הבית ב-iOS:
              </p>
            </IonText>
            {IOS_STEPS.map((step, idx) => (
              <div key={idx} style={{ marginBottom: 24 }}>
                <h3>{step.title}</h3>
                <IonText>
                  <p>{step.text}</p>
                </IonText>
              </div>
            ))}
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: 24,
            paddingBottom: 16,
          }}
        >
          <IonButton expand="block" onClick={onDismiss}>
            סגור
          </IonButton>
        </div>
      </IonContent>
    </IonModal>
  );
}
